import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "../shuttle_bus_booking.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
} from "./configData";
import { fetchSetMaximumList } from "../../../store/shuttle_bus_booking/set_maximum";
import { useEffect, useState } from "react";
import { deleteSetStationById, fetchSetStationList } from "../../../store/shuttle_bus_booking/set_station";
import { SHUTTLE_BUS_BOOKING_SET_STATION_DETAILS, SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE } from "../../../routes";
import { ShowDialog } from "../../../components/reusableItems/dialog";

export const ShuttleBusBookingSetStationListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [tempData, setTempData] = useState([]);

  const { loading, set_station_list } = useSelector(
    (state) => state.shuttleBusSetStation
  );

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "bus_booking.access_bus_booking_station"
  );

  const AddPermssion = checkPermission(
    userPermissions,
    "bus_booking.create_bus_booking_station"
  ) || false;


  const getData = async (callback) => {
    dispatch(fetchSetStationList()).then((res) => {
      const formattedData = res.payload.map(item => ({
        ...item,
        id: item.station_id
      }));

      setTempData([...formattedData]);
    });
  };

  const actionTrigger = () => {
    if (actionType === "Delete") {
      setShowDelete(false);
      
      dispatch(deleteSetStationById(actionID)).then((res) => {
        getData();

      });
    }
  };


  useEffect(() => {
    getData();
  }, []);


  const handleTableClick = (type, id) => {

    if (type === "View Details") {
      navigate(`${SHUTTLE_BUS_BOOKING_SET_STATION_DETAILS}?id=${id}`);
    } else if (type === "Delete") {
      
      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    }

  };

  const RefreshData = () => {
    getData();
  };




  const handleCreateAction = () => {
    navigate(SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE);
  };

  const icons = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];


  return (
    <>
      {viewPermssion ? (
        <div className="container">



          <TableHeader title={"Set Station"} icons={icons} />

          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}


          {(<div className="shuttle_bus_booking_child_box_main_detail_box">


            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                key={tempData && tempData.map(i => i.station_id).join("-")}
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={""}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
